module.exports = __webpack_public_path__ + "img/pencil-landscape_en.522aaac.jpg";